// Update these periodically to the latest browser versions
const LATEST_CHROMIUM_VERSION = 108;
const LATEST_EDGE_VERSION = LATEST_CHROMIUM_VERSION;
const LATEST_FIREFOX_VERSION = 105;
const LATEST_SAFARI_VERSION = 15;

const MINIMUM_BROWSER_VERSIONS = [
  {
    // Chrome
    regex: /\bChrome\/(\d+)/,
    minVersion: LATEST_CHROMIUM_VERSION - 5,
  },
  {
    // Chromium Edge (uses "Edg/" instead of "Edge/" to distinguish from non-Chromium Edge)
    regex: /\bEdg\/(\d+)/,
    minVersion: LATEST_EDGE_VERSION - 5,
  },
  {
    // Firefox
    regex: /\bFirefox\/(\d+)/,
    minVersion: LATEST_FIREFOX_VERSION - 5,
  },
  {
    // Safari, only include 2 major versions (current and one older)
    regex: /\bVersion\/(\d+).*\bSafari\//,
    minVersion: LATEST_SAFARI_VERSION - 1,
  },
];

export const isOldBrowser = agent =>
  MINIMUM_BROWSER_VERSIONS.some(browser => {
    const match = browser.regex.exec(agent);
    if (match) {
      const version = parseInt(match[1], 10);
      return version < browser.minVersion;
    }

    return false;
  });
